import { render } from "./instagram3.vue?vue&type=template&id=4cfbad74"
import script from "./instagram3.vue?vue&type=script&lang=js"
export * from "./instagram3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__